






























import { Component, Prop, Vue } from 'vue-property-decorator'
import { LoginProfile } from '../types'

@Component
export default class Profiles extends Vue {
  @Prop({ type: Array, required: true }) readonly profiles!: LoginProfile[]
}
